import { render } from "./BattleSquad.vue?vue&type=template&id=7ccba049&scoped=true&ts=true"
import script from "./BattleSquad.vue?vue&type=script&lang=ts"
export * from "./BattleSquad.vue?vue&type=script&lang=ts"

import "./BattleSquad.vue?vue&type=style&index=0&id=7ccba049&lang=scss&scoped=true"

import exportComponent from "/Users/macbook/Documents/work_code/global/events_gevents.37games.com/src/resource/guidetro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ccba049"]])

export default __exports__